import React from 'react';

const steps = [
  { n: '1', title: 'Connect your channels', desc: 'Instagram, WhatsApp, LinkedIn… one click. No API keys to copy.' },
  { n: '2', title: 'We tune your operator', desc: 'Your voice, your offer, your goals, when to hand over. In plain language.' },
  { n: '3', title: 'Salesyo drives revenue', desc: 'You track conversations, closes and generated value in real time.' }
];

function Setup() {
  return (
    <section id="process" style={{ paddingTop: 0 }}>
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">Setup</div>
          <h2>Live in under 10 minutes</h2>
          <p>Done-for-you service. We configure everything with you.</p>
        </div>
        <div className="steps">
          {steps.map((s) => (
            <div className="step" key={s.n}>
              <div className="n">{s.n}</div>
              <h4>{s.title}</h4>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Setup;
